import React, { useEffect } from "react";
import { useRef } from "react";
import useOutsideClick from "../../hooks/useOutsideClick";
import { MdClose } from "react-icons/md";
import { categories } from "../../data/dataCheckboxes";
import { FiFilter } from "react-icons/fi";
import CustomCheckBox from "../common/CustomCheckBox";
import { Oval } from "react-loader-spinner";
import TagItem from "../common/TagItem";
import TagCheckbox from "../common/TagCheckbox";
const ResultFilters = ({
  show,
  setShow,
  filter,
  setFilter,
  initialFilter,
  handleChangeCheckBox,
  isLoading,
  popular_categories,
  popular_keywords,
}) => {
  const handleClose = () => {
    setShow(false);
  };
  const modalRef = useRef(null);
  useOutsideClick(modalRef, handleClose, null, show);
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);

  return (
    <div
      className={`w-full h-screen flex lg:hidden justify-center items-end bg-[#241b4795] backdrop-blur-md fixed top-0 left-0 z-50 roboto-font transition-all duration-300 ease-in `}
    >
      <div
        ref={modalRef}
        className="w-full h-[calc(100vh-40px)] flex flex-col gap-y-7 px-6 items-center pb-20 bg-[#F6F5FF] rounded-t-xl animated-bottom-sheet "
      >
        <div className="w-full flex justify-between pt-4 ">
          <button
            onClick={() => {
              setFilter(initialFilter);
            }}
            className="text-sm text-custom-gray-700"
          >
            Clear
          </button>
          <div className="min-w-fit flex items-center font-semibold">
            <FiFilter size={20} className="mr-1.5" color="#4d29d1" />
            Filter
          </div>
          <button onClick={handleClose} className="-mb-1">
            <MdClose className="text-custom-gray-700" size={20} />
          </button>
        </div>

        {/* -------- filter items -------- */}
        <div className={`w-full h-full flex flex-col gap-4 overflow-auto custom-primary-tiny-scroll`}>
          <section className="w-full max-h-[calc(100vh/2-90px)] flex flex-col items-center justify-between rounded-2xl bg-gradient-to-br from-white to-gray-50 pr-3 py-6 shadow-lg">
            <h3 className="text-2xl font-bold mb-6 w-full text-center abel-font bg-gradient-to-r from-[#8538ff] to-[#7e7cff] bg-clip-text text-transparent">
              Popular Categories
            </h3>
            {isLoading ? (
              <div className="w-full h-full flex justify-center items-center min-h-[200px]">
                <Oval
                  height={40}
                  width={40}
                  color="#8538FF"
                  wrapperStyle={{}}
                  wrapperClass=""
                  visible={true}
                  ariaLabel="oval-loading"
                  secondaryColor="#8538FF"
                  strokeWidth={2}
                  strokeWidthSecondary={2}
                />
              </div>
            ) : (
              <div className="w-full flex flex-col gap-2 overflow-auto custom-primary-tiny-scroll px-3 ">
                {popular_categories?.map((item, index) => (
                  <TagItem
                    key={item?.category + index}
                    id={item?.category}
                    title={item?.category}
                    count={item?.count}
                    icon={
                      categories?.find((cat) => cat.title === item?.category)
                        ?.icon
                    }
                    onChange={(e) =>
                      handleChangeCheckBox(e, "category", item?.category)
                    }
                    checked={filter.category.includes(item?.category)}
                    index={index}
                    lblClass="w-full py-1.5"
                    containerClass="w-full"
                  />
                ))}
              </div>
            )}

            {/* ////////// */}
          </section>{" "}
          <section className="w-full max-h-[calc(100vh/2-90px)] flex flex-col items-center justify-between rounded-2xl bg-gradient-to-br from-white to-gray-50 pr-3 py-6 shadow-lg">
            <h3 className="text-2xl font-bold mb-6 w-full text-center abel-font bg-gradient-to-r from-[#8538ff] to-[#7e7cff] bg-clip-text text-transparent">
              Popular Keywords
            </h3>
            {isLoading ? (
              <div className="w-full h-full flex justify-center items-center min-h-[200px]">
                <Oval
                  height={40}
                  width={40}
                  color="#8538FF"
                  wrapperStyle={{}}
                  wrapperClass=""
                  visible={true}
                  ariaLabel="oval-loading"
                  secondaryColor="#8538FF"
                  strokeWidth={2}
                  strokeWidthSecondary={2}
                />
              </div>
            ) : (
              <div className="w-full flex items-center flex-wrap gap-3 overflow-auto custom-primary-tiny-scroll px-3 ">
                {popular_keywords?.map((item, index) => (
                  <TagCheckbox
                    key={item?.keyword + index}
                    id={item?.keyword}
                    title={item?.keyword}
                    count={item?.count}
                    onChange={(e) =>
                      handleChangeCheckBox(e, "keywords", item?.keyword)
                    }
                    checked={filter.keywords.includes(item?.keyword)}
                    index={index}
                    lblClass="py-1.5"
                    containerClass=""
                  />
                ))}
              </div>
            )}
            {/* ////////// */}
          </section>{" "}
          <section className="w-full max-h-[calc(100vh/2-90px)] flex flex-col items-center justify-between rounded-2xl bg-gradient-to-br from-white to-gray-50 px-4 py-6 shadow-lg">
            <h3 className="text-2xl font-bold mb-6 w-full text-center abel-font bg-gradient-to-r from-[#8538ff] to-[#7e7cff] bg-clip-text text-transparent">
              Result Type
            </h3>
            {isLoading ? (
              <div className="w-full h-full flex justify-center items-center min-h-[200px]">
                <Oval
                  height={40}
                  width={40}
                  color="#8538FF"
                  wrapperStyle={{}}
                  wrapperClass=""
                  visible={true}
                  ariaLabel="oval-loading"
                  secondaryColor="#8538FF"
                  strokeWidth={2}
                  strokeWidthSecondary={2}
                />
              </div>
            ) : (
              <div className="w-full flex justify-between ">
                <CustomCheckBox
                  id={"public"}
                  title={"Public"}
                  lblClass="h-9"
                  containerClass="w-1/2 mr-2"
                  checked={filter?.premium?.includes(false)}
                  onChange={(e) => handleChangeCheckBox(e, "premium", false)}
                />
                <CustomCheckBox
                  id={"premium"}
                  title={"Premium"}
                  lblClass="h-9"
                  containerClass="w-1/2"
                  checked={filter?.premium?.includes(true)}
                  onChange={(e) => handleChangeCheckBox(e, "premium", true)}
                />
              </div>
            )}
            {/* ////////// */}
          </section>{" "}
        </div>
      </div>
    </div>
  );
};

export default ResultFilters;
